module.exports = __webpack_public_path__ + "media/images/price_list/reference-2-d3ec9d5648fd298d61b0f901a98a8577.webp";